/**
 * CDN DIT URL'lerinden responsive srcset üretir.
 * Manşet teslimatı: 1920px'e kadar responsive, en-boy oranı sabit.
 */
import { MASTHEAD_DELIVERY_QUALITY } from './image-presets'

const DIT_RE =
  /^(https?:\/\/[^/]+)\/(\d+)x(\d+)\/(\d+)\/(cover|inside)\/(.+)$/i

export function rewriteDitUrl(
  url: string,
  width: number,
  height: number,
  quality: number,
): string {
  const m = String(url || '').match(DIT_RE)
  if (!m) return url
  const [, origin, , , , fit, rest] = m
  return `${origin}/${width}x${height}/${quality}/${fit}/${rest}`
}

function mastheadVariants(url: string, widths: number[]): string | undefined {
  if (!DIT_RE.test(url)) return undefined
  return widths
    .map((width) => `${rewriteDitUrl(url, width, Math.round(width * 5 / 9), MASTHEAD_DELIVERY_QUALITY)} ${width}w`)
    .join(', ')
}

/** Mobil manşet: 2×/3× ekranlarda da yeterli çözünürlük. */
export function mastheadMobileSrcSet(url: string): string | undefined {
  return mastheadVariants(url, [400, 640, 828, 960, 1260, 1440, 1920])
}

/** Masaüstü manşet — tarayıcı konteyner ve ekran yoğunluğuna göre seçer. */
export function mastheadDesktopSrcSet(url: string): string | undefined {
  return mastheadVariants(url, [720, 960, 1260, 1440, 1920])
}

/** @deprecated — picture source'ları tercih et */
export function mastheadSrcSet(url: string): string | undefined {
  const mobile = mastheadMobileSrcSet(url)
  const desktop = mastheadDesktopSrcSet(url)
  if (!mobile || !desktop) return mobile || desktop
  return [...new Set([...mobile.split(', '), ...desktop.split(', ')])].join(', ')
}

/** Srcset desteklenmediğinde de küçük ve bulanık görsel sunma. */
export function mastheadDefaultSrc(url: string): string {
  return rewriteDitUrl(url, 640, 356, MASTHEAD_DELIVERY_QUALITY)
}

/** Masaüstü fallback: standart PNG manşet masterının eski 2× boyutu. */
export function mastheadDesktopDefaultSrc(url: string): string {
  return rewriteDitUrl(url, 1440, 800, MASTHEAD_DELIVERY_QUALITY)
}
